import avatar8 from "assets/images/users/avatar-8.jpg";
import avatar6 from "assets/images/users/avatar-6.jpg";
import avatar5 from "assets/images/users/avatar-5.jpg";
import avatar3 from "assets/images/users/avatar-3.jpg";
import avatar2 from "assets/images/users/avatar-2.jpg";
import avatar1 from "assets/images/users/avatar-1.jpg";

const profileData = [
    {
        id: 1,
        course: "Web Design",
        app: "Chat App Update",
        time: "2 Years Ago",
        badgeClass: "warning",
        textcolor: "warning",
        variant: "primary",
        value: 80,
        data: 80,
        datacolor: "primary",
        img: [{
            id: 1,
            img: avatar1
        },
        {
            id: 2,
            img: avatar3
        },],
        memberName: [
            {
                id: 1,
                memberText: "J"
            }
        ]
    },
    {
        id: 2,
        course: "Dashboard",
        app: "Client - Frank Hook",
        time: "1 Years Ago",
        badgeClass: "secondary",
        textcolor: "secondary",
        data: 65,
        value: 65,
        variant: "warning",
        datacolor: "warning",
        img: [{
            id: 1,
            img: avatar1
        },
        {
            id: 2,
            img: avatar3
        },],
        memberName: [
            {
                id: 1,
                memberText: "M"
            }
        ]
    },
    {
        id: 3,
        course: "App Development",
        app: "Steex Project",
        time: "11 Years Ago",
        badgeClass: "success",
        textcolor: "success",
        data: 23,
        value: 23,
        variant: "danger",
        datacolor: "danger",
        img: [{
            id: 1,
            img: avatar2
        },
        {
            id: 2,
            img: avatar5
        },],
    },
    {
        id: 4,
        course: "Web design",
        app: "Brand Logo Design",
        time: "10 min Ago",
        badgeClass: "secondary",
        textcolor: "secondary",
        variant: "success",
        datacolor: "success",
        data: 100,
        value: 100,
        img: [{
            id: 1,
            img: avatar1
        },
        {
            id: 2,
            img: avatar3
        },],
        memberName: [
            {
                id: 1,
                memberText: "E"
            }
        ]
    },
    {
        id: 5,
        course: "Web Development",
        app: "Chat App",
        time: "8 hr Ago",
        badgeClass: "info",
        textcolor: "info",
        variant: "primary",
        datacolor: "primary",
        data: 68,
        value: 68,
        img: [{
            id: 1,
            img: avatar1
        },
        {
            id: 2,
            img: avatar3
        },],
        memberName: [
            {
                id: 1,
                memberText: "R"
            }
        ]
    },
    {
        id: 6,
        course: "Mobile App",
        app: "Project Update",
        time: "48 min Ago",
        badgeClass: "warning",
        textcolor: "warning  ",
        variant: "info",
        datacolor: "info",
        data: 76,
        value: 76,
        img: [
            {
                id: 1,
                img: avatar6
            },
            {
                id: 2,
                img: avatar2
            },
            {
                id: 3,
                img: avatar5
            }
        ]
    },
    {
        id: 7,
        course: "Web Design",
        app: "Business Template - UI/UX design",
        time: "7 months Ago",
        badgeClass: "danger",
        textcolor: "danger",
        variant: "info",
        datacolor: "info",
        data: 79,
        value: 79,
        img: [{
            id: 1,
            img: avatar6
        },
        {
            id: 2,
            img: avatar8
        },
        {
            id: 3,
            img: avatar3
        }],
        memberName: [
            {
                id: 1,
                memberText: "R"
            }
        ]
    },
    {
        id: 8,
        course: "Web Design",
        app: "Business Template - UI/UX design",
        time: "7 months Ago",
        badgeClass: "danger",
        textcolor: "danger",
        variant: "danger",
        datacolor: "danger",
        data: 100,
        value: 100,
        img: [{
            id: 1,
            img: avatar8
        },
        {
            id: 2,
            img: avatar3
        },],
        memberName: [
            {
                id: 1,
                memberText: "R"
            }
        ]
    },
    {
        id: 9,
        course: "Mobile App",
        app: "ABC Project Customization",
        time: "2 months Ago",
        badgeClass: "primary",
        textcolor: "primary",
        variant: "success",
        datacolor: "success",
        data: 100,
        value: 100,
        img: [{
            id: 1,
            img: avatar8
        },
        {
            id: 2,
            img: avatar3
        },],
        memberName: [
            {
                id: 1,
                memberText: "R",
            }
        ]
    }
]
export { profileData }

